module.exports = __webpack_public_path__ + "r-v3/img/plus_white.e0ffe094.svg";